import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControl, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from "highcharts/highcharts-more";
import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardHeaderLoading from "../../components/cfcDashboard/DashboardHeaderLoading";
import { cfpBaseUrl } from "../../network/urls";
import "./CfcDashboard.scss";

const CommercialServicesCard = lazy(() => import("../../components/commercialServicesCard/CommercialServicesCard"));
const DashboardHeader = lazy(() => import("../../components/cfcDashboard/DashboardHeader"));

HighchartsMore(Highcharts);

const TechnicalOperations = () => {
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const dispatch = useDispatch();

    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, roleId, hierarchy } = useSelector(state => state.auth)
    const [companyCode, setCompanyCode] = useState('15')
    const [desginationCodeToApi, setDesginationCodeToApi] = useState("113");
    const [desginationList, setDesginationList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [disco, setDisco] = useState("15");
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedDesignations, setSelectedDesignations] = useState([113]);
    const [selectedDesignationsForApi, setSelectedDesignationsForApi] = useState("113");
    const navigate = useNavigate();
    const handleChangeDesgination = (e) => {
        console.log(e.target.value, 'e.target.value')
        setDesginationCodeToApi(e.target.value)
    }
    const tableRef = useRef(null);

    const getDateDifference = (startDate, endDate) => {
        // Convert the date strings to Date objects
        const startDates = startDate.split(',')[0]
        const endDates = endDate.split(',')[0]

        const start = new Date(startDates);
        const end = new Date(endDates);

        // Calculate the difference in time (milliseconds)
        const differenceInTime = end - start;

        // Convert time difference from milliseconds to days
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return differenceInDays;
    };

    const handleChange = (event) => {
        // setSelectedDesignations(event.target.value);
        const selectedValues = event.target.value; // e.g., [1135, 96, 98]
        // const selectedString = selectedValues.join(','); // e.g., "1135,96,98"
        setSelectedDesignations(event.target.value);
        const selectedString = selectedValues.join(',');
        console.log(selectedString, 'selectedString')
        setSelectedDesignationsForApi(selectedString);
    };
    const [complaintCharts, setComplaintCharts] = useState({
        chart: {
            type: 'pie',
            zooming: {
                type: 'xy'
            },
            panning: {
                enabled: true,
                type: 'xy'
            },
            panKey: 'shift'
        },
        title: {
            text: 'Technical Complaints'
        },
        tooltip: {
            valueSuffix: '%'
        },
        subtitle: {
            text: null
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    distance: -40,
                    format: '{point.percentage:.1f}%',
                    style: {
                        fontSize: '1.2em',
                        textOutline: 'none',
                        opacity: 0.7
                    },
                    filter: {
                        operator: '>',
                        property: 'percentage',
                        value: 10
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {

            }
        ]
    });
    const statusRouteMap = {
        Pending: "/power-complaint-pending",
        Allocated: "/power-complaint-allocated",
        Working: "/power-complaint-working",
        Onhold: "/power-complaint-onhold",
        Escalated: "/power-complaint-escalated",
        Resolved: "/power-complaint-resolved",
    };
    const [serviceCards, setServiceCards] = useState([

    ])



    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const getData = async () => {
        try {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                officeCode:
                    hierarchy == 1 ? disco :
                        hierarchy == 2 ? code.slice(0, 2) :
                            hierarchy == 3 ? code.slice(0, 3) :
                                hierarchy == 4 ? code.slice(0, 4) :
                                    hierarchy == 52 ? code : '15',
                dateFrom: getCurrentDate(),
                dateTo: getCurrentDate()
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "lineComplaints/getComplaintCountStatusWiseHierarchical", requestOptions);
            const result = await response.json();

            if (result.status == 200) {
                const statusColorMap = {
                    Pending: "#FFCDD2",
                    Allocated: "#B2EBF2",
                    Working: "#C8E6C9",
                    Onhold: "#D1C4E9",
                    Escalated: "#FFF9C4",
                    Resolved: "#A5D6A7",
                    Total: "#FFE0B2"
                };

                // ✅ Required statuses for sum
                const requiredStatuses = ["Pending", "Allocated", "Working", "Onhold", "Resolved"];

                let cards = [];

                const statusSumMap = {
                    Pending: 0,
                    Allocated: 0,
                    Working: 0,
                    Onhold: 0,
                    Resolved: 0
                };

                result.data.forEach(item => {
                    const statusKey = item.Status?.toLowerCase();
                    const matchedKey = Object.keys(statusSumMap).find(
                        key => key.toLowerCase() === statusKey
                    );
                    if (matchedKey) {
                        statusSumMap[matchedKey] += item.TotalCount || 0;
                    }
                });

                // ✅ Create cards from summed values
                cards = Object.keys(statusSumMap).map(status => ({
                    title1: status,
                    title2: "Complaints",
                    yearlyCounter: statusSumMap[status],
                    color: statusColorMap[status],
                    onClick: () => navigate(statusRouteMap[status]),
                }));

                const totalCount = Object.values(statusSumMap).reduce((acc, curr) => acc + curr, 0);
                cards.push({
                    title1: "Total",
                    title2: "Complaints",
                    yearlyCounter: totalCount,
                    color: statusColorMap["Total"],
                    onClick: null,
                });

                // ✅ Update chart
                const updatedComplaintCharts = {
                    ...complaintCharts,
                    series: [
                        {
                            name: "Percentage",
                            colorByPoint: true,
                            data: cards
                                .filter(card => card.title1 !== "Total")
                                .map(card => ({
                                    name: card.title1,
                                    y: card.yearlyCounter,
                                    color: card.color
                                }))
                        }
                    ]
                };

                if (result.data && cards.length > 0) {
                    setComplaintCharts(updatedComplaintCharts);
                    setServiceCards(cards);
                    setIsDataLoaded(true);
                    setViewBackdrop(false);
                } else {
                    console.error("No valid data returned from API");
                    setServiceCards([]);
                    setComplaintCharts({
                        ...complaintCharts,
                        series: [{ name: "Percentage", colorByPoint: true, data: [] }]
                    });
                    setIsDataLoaded(false);
                    setViewBackdrop(false);
                }

                return cards;
            } else if (result.status == 400) {
                setServiceCards([]);
                setComplaintCharts({
                    ...complaintCharts,
                    series: [{ name: "Percentage", colorByPoint: true, data: [] }]
                });
                setIsDataLoaded(true);
                setViewBackdrop(false);
            } else if (result.status == 401) {
                // ... existing logout logic
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            setServiceCards([]);
            setComplaintCharts({
                ...complaintCharts,
                series: [{ name: "Percentage", colorByPoint: true, data: [] }]
            });
            setIsDataLoaded(false);
            setViewBackdrop(false);
        }
    };


    useEffect(() => {
        getData()
    }, [])

    const handleChangeCompany = (e) => {
        setCompanyCode(e.target.value)
    }

    useEffect(() => {
        if (hierarchy == 52) {
            getStats()
        }
    }, [desginationCodeToApi])
    const connectionTypes = [
        'User Name',
        'Sub Division Name',
        'Role Name',
        // 'SDIV Count',
        'LoggedIn User',
        'LoggedOut User',
        // 'Total '
    ];


    const getDesgination = async () => {

        setViewBackdrop(true)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const raw = "";

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
            .then((response) => response.json())
            .then((result) => {

                if (result.message == 'Data Found.') {
                    const requiredDesignations = ["LM-I", "LM-II", "LS-I", "LS-II", "ALM"];

                    const filtered = result.data.filter(item =>
                        requiredDesignations.includes(item.employeeDesignationName?.toUpperCase())
                    );
                    console.log("Desgntion", result.data)
                    setDesginationList(filtered)
                }
                // setViewBackdrop(false)
            })
            .catch((error) => console.error(error));
    }
    useEffect(() => {
        if (hierarchy == 52) {
            getDesgination()
        }
    }, [])
    const getStats = async () => {
        setViewBackdrop(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                officeCode: hierarchy == 1 ? disco : hierarchy == 2 ? code.slice(0, 2) : hierarchy == 3 ? code.slice(0, 3) : hierarchy == 4 ? code.slice(0, 4) : hierarchy == 52 ? code : '15',
                roleId: selectedDesignationsForApi ? selectedDesignationsForApi : '113',
                isLoggedInFromMobile: '2',
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + "workForce/getUserLoggedStatus", requestOptions);
            const result = await response.json();

            if (result.status == '200') {
                setViewBackdrop(false);
                setTableData(result.data)
                console.log(result.data, 'result.data')
            } else {
                setViewBackdrop(false);
                setTableData([])
            }
        } catch (error) {
            console.error("Error fetching stats:", error);
            setTableData([]); // Clear tableData on error
        }
        // setViewBackdrop(false);
    };

    const updatedTableData = tableData.map((item) => {
        const isLoggedIn = item.isLogged_In === true;

        return {
            ...item,
            LoggedInLineStaff: isLoggedIn ? 1 : 0,
            NeverLoggedInLineStaff: !isLoggedIn ? 1 : 0,
            totalLineStaff: 1
        };
    });

    const handleConfirm = () => {
        if (hierarchy == 52) {
            getStats()
        }
    };

    return (
        <>

            <Box className="form-box">
                <div className="cfc-dashboard">
                    <Suspense fallback={<DashboardHeaderLoading />}>
                        {isDataLoaded ? (
                            serviceCards && serviceCards.length > 0 ? (
                                <DashboardHeader
                                    title="Customer Services"
                                    serviceCards={serviceCards}
                                />
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <Typography variant="h6" style={{ color: '#999' }}>
                                        No Data Found
                                    </Typography>
                                </div>
                            )
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                <CircularProgress />
                                <Typography variant="h6" style={{ marginTop: 20, color: '#666' }}>
                                    Loading Data...
                                </Typography>
                            </div>
                        )}
                    </Suspense>
                </div>

                <div style={{ width: '100%', margin: '20px 0' }}>
                    {isDataLoaded ? (
                        serviceCards && serviceCards.length > 0 ? (
                            <HighchartsReact highcharts={Highcharts} options={complaintCharts} />
                        ) : (
                            <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                <Typography variant="h5" style={{ color: '#999', fontSize: '20px' }}>
                                    No Data Found
                                </Typography>
                            </div>
                        )
                    ) : (
                        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography style={{ color: '#999', fontSize: '18px' }}>
                                Loading chart...
                            </Typography>
                        </div>
                    )}
                </div>
            </Box>

            {/* Second Box added vertically below */}
            {
                hierarchy == 52 && (
                    <Box className="form-box">
                        <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Lineman App Usage Summary</h3>
                        <div className='div-datagrid' >
                            <div className='reports-container' >
                                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>

                                    {
                                        code == 10 &&

                                        <div className='field-container'>
                                            <Typography className='field-label'>Company</Typography>
                                            <select
                                                className='dropdown-field'
                                                style={{ backgroundColor: 'white' }}
                                                value={companyCode}
                                                onChange={handleChangeCompany}>
                                                <option value={11}>LESCO</option>
                                                <option value={12}>GEPCO</option>
                                                <option value={13}>FESCO</option>
                                                <option value={14}>IESCO</option>
                                                <option value={15}>MEPCO</option>
                                                <option value={26}>PESCO</option>
                                                <option value={37}>HESCO</option>
                                                <option value={38}>SEPCO</option>
                                                <option value={48}>QESCO</option>
                                                <option value={59}>TESCO</option>

                                            </select>
                                        </div>
                                    }

                                    <div style={{ display: 'flex', marginTop: 20 }}>
                                        <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
                                            <Typography className='field-label'>Designation</Typography>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="designation-select-label"
                                                    multiple
                                                    value={selectedDesignations}
                                                    onChange={handleChange}
                                                    style={{ backgroundColor: 'white', height: 30, width: 300 }}
                                                    renderValue={(selected) =>
                                                        selected
                                                            .map((id) =>
                                                                desginationList.find((item) => item.employeeDesignationId === id)
                                                                    ?.employeeDesignationName || id
                                                            )
                                                            .join(', ')
                                                    }
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: { width: 300 },
                                                        },
                                                    }}
                                                >
                                                    {desginationList.map((item) => (
                                                        <MenuItem key={item.employeeDesignationId} value={item.employeeDesignationId}>
                                                            <Checkbox checked={selectedDesignations.includes(item.employeeDesignationId)} />
                                                            <ListItemText primary={item.employeeDesignationName} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                        </div>
                                        <div style={{ marginLeft: 25, marginTop: 30 }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ marginTop: '10px' }}
                                                onClick={handleConfirm}
                                            >
                                                Go
                                            </Button>
                                        </div>

                                    </div>

                                </div>

                                <div className="export-button-container">

                                </div>
                            </div>
                            <div className="table-container" style={{ marginBottom: '40px' }}>
                                <div id="pdf-table">
                                    <div style={{ maxHeight: '900px', overflowY: 'auto' }}>
                                        <table
                                            className="table"
                                            ref={tableRef}
                                            style={{
                                                marginBottom: '20px',
                                                width: '100%',
                                                borderCollapse: 'separate',
                                                borderSpacing: '0 10px',
                                            }}
                                        >
                                            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
                                                <tr style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 3 }}>
                                                    <th colSpan="14" style={{ fontSize: '20px', textAlign: 'center', backgroundColor: '#d5e5ff', color: 'black', }}>
                                                    </th>
                                                </tr>
                                                <tr style={{}}>
                                                    {connectionTypes.map((type, index) => (
                                                        <th
                                                            key={index}
                                                            style={{
                                                                width: `${100 / connectionTypes.length}%`,
                                                                textAlign: 'left',
                                                                border: '5px solid white',
                                                                fontSize: '14px',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                            }}
                                                        >
                                                            {type}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {updatedTableData.length > 0 ? (
                                                    <>
                                                        {updatedTableData.map((item, id) => {
                                                            const role = desginationList.find(designation => designation.employeeDesignationId === item.role_id);
                                                            return (
                                                                <tr key={id} style={{ backgroundColor: 'white', borderBottom: "1px solid #ccc" }}>
                                                                    <td style={{ textAlign: 'left' }}>{item.userName || '-'}</td>
                                                                    <td style={{ textAlign: 'left' }}>{item.subDivisionName || '-'}</td>
                                                                    <td style={{ textAlign: 'left' }}>{role?.employeeDesignationName || '-'}</td>
                                                                    <td style={{ textAlign: 'left' }}>{item.LoggedInLineStaff}</td>
                                                                    <td style={{ textAlign: 'left' }}>{item.NeverLoggedInLineStaff}</td>
                                                                    {/* <td style={{ textAlign: 'left' }}>{item.totalLineStaff}</td> */}
                                                                </tr>
                                                            );
                                                        })}

                                                        <tr style={{ backgroundColor: '#fef5c0' }}>
                                                            <td colSpan={3} style={{ textAlign: 'left' }}>Total ({updatedTableData.reduce((sum, item) => sum + item.totalLineStaff, 0)})</td>
                                                            <td style={{ textAlign: 'left' }}>
                                                                {updatedTableData.reduce((sum, item) => sum + item.LoggedInLineStaff, 0)}
                                                            </td>
                                                            <td style={{ textAlign: 'left' }}>
                                                                {updatedTableData.reduce((sum, item) => sum + item.NeverLoggedInLineStaff, 0)}
                                                            </td>
                                                            {/* <td style={{ textAlign: 'left' }}>
                                                            {updatedTableData.reduce((sum, item) => sum + item.totalLineStaff, 0)}
                                                        </td> */}
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: 'red' }}>
                                                            No Data Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>


                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Box>
                )
            }



            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
            {/* <div style={{ background: 'red', width: '50%' }}>

            </div> */}
        </>
    );
};

export default TechnicalOperations;
